module.exports = __webpack_public_path__ + "img/logo-jurisprudencia.ad5d405d.png";